import md5 from 'crypto-js/md5';
export function hash(content) {
  return md5(content).toString();
}
//# sourceMappingURL=hash.js.map